import { render, staticRenderFns } from "./FormEmployeeSituation.vue?vue&type=template&id=64a8cb53"
import script from "./FormEmployeeSituation.vue?vue&type=script&lang=js"
export * from "./FormEmployeeSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports